import { instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";
import { SharingSchedulesSettings } from "../../sharing.types";

export const requestSharingSchedulesSettings =
  async (): Promise<SharingSchedulesSettings> => {
    return await instance.get(ApiRoutesSharing.SharingSchedulesSettings);
  };
